<template>
    <svg viewBox="0 -3 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.2125 0.782687L8.28319 6.60033L1.72918 7.53625C0.553853 7.70322 0.0828258 9.12248 0.935161 9.93536L5.67683 14.4612L4.55534 20.8544C4.35347 22.01 5.59609 22.8757 6.63683 22.3352L12.5 19.3165L18.3632 22.3352C19.4039 22.8713 20.6465 22.01 20.4447 20.8544L19.3232 14.4612L24.0648 9.93536C24.9172 9.12248 24.4461 7.70322 23.2708 7.53625L16.7168 6.60033L13.7875 0.782687C13.2626 -0.254294 11.7419 -0.267476 11.2125 0.782687Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "StarIcon",
};
</script>
